/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 * Create serializer for DatasetPipeline.
 *
 * - ``perturbations``: list of perturbation PKs.
 * - ``inferencer_id``: optional FK to an **existing** inferencer. Create the
 *   inferencer first with ``POST /api/inferencers/single_turn_chat/``, then pass the returned ``id``
 *   here. The legacy key ``inferencer`` is accepted as an alias for ``inferencer_id``.
 *
 * Response uses :class:`DatasetPipelineSerializer` (nested ``inferencer`` object).
 * @export
 * @interface DatasetPipelineCreate
 */
export interface DatasetPipelineCreate {
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineCreate
   */
  aiModel: number;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPipelineCreate
   */
  taskType?: TaskTypeEnum | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineCreate
   */
  generationInputs?: number | null;
  /**
   *
   * @type {Array<number>}
   * @memberof DatasetPipelineCreate
   */
  perturbations?: Array<number>;
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineCreate
   */
  dataset?: number | null;
  /**
   *
   * @type {string}
   * @memberof DatasetPipelineCreate
   */
  taskName?: string | null;
  /**
   *
   * @type {number}
   * @memberof DatasetPipelineCreate
   */
  inferencerId?: number | null;
}

/**
 * Check if a given object implements the DatasetPipelineCreate interface.
 */
export function instanceOfDatasetPipelineCreate(value: object): value is DatasetPipelineCreate {
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  return true;
}

export function DatasetPipelineCreateFromJSON(json: any): DatasetPipelineCreate {
  return DatasetPipelineCreateFromJSONTyped(json, false);
}

export function DatasetPipelineCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetPipelineCreate {
  if (json == null) {
    return json;
  }
  return {
    aiModel: json['ai_model'],
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    generationInputs: json['generation_inputs'] == null ? undefined : json['generation_inputs'],
    perturbations: json['perturbations'] == null ? undefined : json['perturbations'],
    dataset: json['dataset'] == null ? undefined : json['dataset'],
    taskName: json['task_name'] == null ? undefined : json['task_name'],
    inferencerId: json['inferencer_id'] == null ? undefined : json['inferencer_id'],
  };
}

export function DatasetPipelineCreateToJSON(value?: DatasetPipelineCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    ai_model: value['aiModel'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
    generation_inputs: value['generationInputs'],
    perturbations: value['perturbations'],
    dataset: value['dataset'],
    task_name: value['taskName'],
    inferencer_id: value['inferencerId'],
  };
}
